import React, { useState, useEffect } from "react";
import Slider from "react-slick";

export default function OngoingLeagues() {
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
    const [activeIndex, setActiveIndex] = useState(0)
  let slider1, slider2;

  const games = [
    {
      name: "Formula Speed UAE",
      shortDescription:
        "Yalla Formula brings the Formula 1 inspired racing to your mobile browser, offering a real 3D experience with immersive environments. Dubai & Abu Dhabi Inspired: Inspired by the streets and buildings of Dubai & Abu Dhabi, players will race through virtual streets of the city.",
      ageRating: "3+",
      graphic: "https://cdn-dc.veniso.net/obigin-website/FormulaSpeedBanner_1.jpg",
      link: "https://www.obigin.com/details/688b0a181e03f7681287957a",
      vertical: "/assets/img/images/FormulaSpeedBanner_1.jpg",
    },
    {
      name: "Cricket Premier League",
      shortDescription:
        "Cricket Digital Premier League (DPL) is the first cricket league online for Nepal. Choose your province to contribute your performance for your team.",
      ageRating: "7+",
      graphic: "https://cdn-dc.veniso.net/obigin-website/CricketBanner_1.jpg",
      link: "https://www.obigin.com/details/6889fef01e03f76812878d4d",
      vertical: "/assets/img/images/CricketBanner_2.jpg",
    },
    {
      name: "Digital Super League",
      shortDescription:
        "Digital Super League (DSL) is the first football league online tournament. Choose your CLUB to contribute your performance for your team. True Realtime multiplayer gaming environment. Story based football tournament with Penalty shootout to play and help your team to win.",
      ageRating: "12+",
      graphic: "https://cdn-dc.veniso.net/obigin-website/FootballPenaltyShootOutBanner_1.jpg",
      link: "https://www.obigin.com/details/688a05621e03f76812878e2a",
      vertical: "/assets/img/images/FootBallPenaltyShootoutBanner_2.jpg",
    },
    {
      name: "Baghchal",
      shortDescription:
        "Get connected with Nepal’s first casual gaming community. Features an advanced 3D UI design. Create your own chat room and invite your friends to play. Play with friends & Family online.",
      ageRating: "All",
      graphic: "https://res.cloudinary.com/daoussy77/image/upload/v1752996614/Banner.jpg_x1uop8.webp",
      link: "https://obigin.mudgames.in/app/game.php?cgame=baghchal",
      vertical: "https://res.cloudinary.com/daoussy77/image/upload/v1752996630/Baghchal4_qg5709.png",
    },
  ];

  useEffect(() => {
    setNav1(slider1);
    setNav2(slider2);
  }, [slider1, slider2]);

  return (
    <section className="released-games-area gray-bg pt-115 pb-70">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-6 col-lg-8">
            <div className="section-title title-style-three text-center mb-20">
              <h2>
                Ongoing <span>Leagues</span>
              </h2>
              <p>
                Power‑packed native titles built for buttery‑smooth play,
                stunning 3‑D visuals and endless replayability.
              </p>
            </div>
          </div>
        </div>
        <div className="row align-items-center">
          <div className="col-xl-8 col-lg-12">
            <Slider
              className="released-game-active"
              asNavFor={nav2}
              ref={(slider) => (slider1 = slider)}
              arrows={false}
              autoplay={true}
            >
              {games.map((game, index) => (
                <div key={index} className="released-game-carousel">
                  <div className="released-game-item">
                    <div className="released-game-item-bg" />
                    <div className="released-game-img">
                      <img
                        src={game.vertical}
                        style={{ height: 392, width: 375 }}
                        alt={game.name}
                      />
                    </div>
                    <div className="released-game-content">
                      <div className="released-game-rating">
                        <h5>Age Rating: </h5>
                        {game.ageRating}
                      </div>
                      <h4>{game.name}</h4>
                      <div className="released-game-list mb-15">
                        <ul>
                          <li>
                            <span>Category :</span> Browser
                          </li>
                        </ul>
                      </div>
                      <p className="released-game-dis">{game.shortDescription}</p>
                      <a target='_blank' rel="noreferrer" href={game.link} className="btn btn-style-two">
                        Play Now
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
          <div className="col-xl-4 col-lg-12" style={{ maxHeight: "25rem" }}>
            <Slider
              className="released-game-nav"
              asNavFor={nav1}
              swipeToSlide={true}
              focusOnSelect={true}
              ref={(slider) => (slider2 = slider)}
              slidesToShow={3}
              vertical={true}
              arrows={false}
              autoplay={true}
              beforeChange={(_, next) => setActiveIndex(next)}
            >
              {games.map((game, index) => (
                <div key={index} className={`released-game-nav-item ${index === activeIndex ? "active" : ""
                    }`}>
                  <img
                    style={{ width: 345, height: 131 }}
                    src={game.graphic}
                    alt={game.name}
                  />
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </section>
  );
}
